import { Component, inject, OnInit, signal, viewChildren } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';

import { ChrComponentsModule } from '@ciphr-design-system/angular';

import { CollectionFilter } from '../../../models/collection-filter.type';
import { CollectionFilterDirective } from '../filters/collection-filter.directive';
import { CollectionFilteringStore } from '../../../state/collection-filtering.store';
import { CollectionFilterTypes } from '../../../models/collection-filter-types.enum';
import { CollectionFilterValue } from '../../../models/collection-filter-value.type';
import { DateCollectionFilterComponent } from '../filters/date/date-collection-filter.component';
import { DictionaryCollectionFilterComponent } from '../filters/dictionary/dictionary-collection-filter.component';

@Component({
  selector: 'ciphr-collection-filters-drawer',
  standalone: true,
  imports: [
    TranslocoDirective,
    ChrComponentsModule,
    CollectionFilterDirective,
    DictionaryCollectionFilterComponent,
    DateCollectionFilterComponent,
  ],
  templateUrl: './collection-filters-drawer.component.html',
  styleUrl: './collection-filters-drawer.component.scss',
})
export class CollectionFiltersDrawerComponent implements OnInit {
  private readonly collectionFilteringStore = inject(CollectionFilteringStore);

  private readonly filterComponents = viewChildren(CollectionFilterDirective);

  private readonly selectedFilters = new Map<CollectionFilter['key'], CollectionFilterValue['value'][]>();
  readonly collectionFilterTypes = CollectionFilterTypes;
  readonly expandedFilterIndex = signal<number | null>(null);
  readonly filters = this.collectionFilteringStore.availableFilters;
  readonly opened = this.collectionFilteringStore.drawerOpened;

  component = DictionaryCollectionFilterComponent;

  ngOnInit(): void {
    this.collectionFilteringStore.loadFilters();
  }

  clearFilters(): void {
    this.filterComponents().forEach((filter) => filter.clearSelectedValues());
    this.collectionFilteringStore.clearFilters();
  }

  closeDrawer(): void {
    this.collectionFilteringStore.closeDrawer();
  }

  setFilters(): void {
    const activeFilters = Array.from(this.selectedFilters)
      .map(([key, values]) => ({ key, values }))
      .filter((filter) => filter.values.length);

    this.collectionFilteringStore.setFilters(activeFilters);
  }

  setFilterValuesSelection(filterKey: CollectionFilter['key'], values: CollectionFilterValue['value'][]): void {
    this.selectedFilters.set(filterKey, values);
  }

  toggleFilterExpansion(index: number): void {
    this.expandedFilterIndex.set(this.expandedFilterIndex() === index ? null : index);
  }
}
